export const MAX_SEARCH_LENGTH = 50;

export const getMappedDriveApplications = (driveApplications) => driveApplications?.map(driveApp => ({
    label: driveApp.applicationDescription,
    value: driveApp.applicationId
})) || [];

export const formatPropertyKeyForId = (propertyKey) => {
    return propertyKey?.toLowerCase().split(' ').join('') || '';
};

export const filteredGatewayFromGatewayList = (gatewayList, id) => {
    return gatewayList?.find(gateway => gateway?.gatewayIdentifier === id) || null;
};

export const getGatewayManagementMenus = (translate, routes, IconBroadcast, IconEvents, GatewayManagementComponent, GatewayEvents, options = {}) => {
    const { props, gatewayAdminReadView, gatewayAdminView } = options;
    const isGatewayReadOnlyMode = gatewayAdminReadView === true && gatewayAdminView !== true;
    const menus = [
        {
            id: 1,
            label: translate('ABB.Powertrain.Frontend.ptToolsGatewayManagementLabel'),
            icon: IconBroadcast,
            path: routes.GatewayManagementGateways,
            component: GatewayManagementComponent,
            componentProps: props,
            requiredCapability: 'GATEWAY_MANAGEMENT_VIEW'
        }
    ];

    if (!isGatewayReadOnlyMode) {
        menus.push({
            id: 2,
            label: translate('ABB.Powertrain.Frontend.ptToolsGatewayEventsLabel'),
            icon: IconEvents,
            path: routes.GatewayManagementGatewayEvents,
            component: GatewayEvents,
            componentProps: props,
            requiredCapability: 'GATEWAY_EVENTS_VIEW'
        });
    }

    return menus;
};
